import { ReactNode } from 'react';

import IconFromSVG from '../../Icon/IconFromSVG/IconFromSVG';

import {
  Badge,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';

import { ConditionalLink, ConditionalTooltip } from 'shared/components/Conditional';
import { PaletteColorsT } from 'shared/models/mui';

import './CardWithIcon.scss';

interface CardWithIconProps {
  icon?: ReactNode;
  svgName?: string;
  iconColor?: PaletteColorsT;
  name: string;
  value?: string | number;
  iconTooltip?: string;
  valueTooltip?: string;
  badgeValue?: string | number;
  badgeColor?: PaletteColorsT;
  badgeShowZero?: boolean;
  width?: string | number;
  disablePadding?: boolean;
  disabled?: boolean;
  titleColor?: PaletteColorsT;
  link?: string;
}
function CardWithIcon({
  icon,
  svgName,
  name,
  value,
  iconColor,
  iconTooltip,
  valueTooltip,
  badgeValue = 0,
  badgeColor = 'secondary',
  badgeShowZero = false,
  width = '25rem',
  disablePadding = true,
  disabled,
  titleColor = undefined,
  link,
}: CardWithIconProps) {
  const theme = useTheme();

  return (
    <ListItem
      style={{
        maxWidth: width,
        color: titleColor && (theme.palette as any)[titleColor as string].main,
      }}
      disablePadding={disablePadding}
      disabled={disabled}
    >
      <ListItemIcon className="list-item-icon">
        <ConditionalTooltip title={iconTooltip}>
          <Badge
            badgeContent={badgeValue}
            color={badgeColor}
            showZero={badgeShowZero}
          >
            {
              icon || <IconFromSVG name={svgName as string} color={iconColor} />
            }
          </Badge>
        </ConditionalTooltip>
      </ListItemIcon>
      <ConditionalTooltip title={valueTooltip} placement="right">
        <ListItemText
          primary={name}
          secondary={(
            <ConditionalLink
              link={link}
              style={{
                left: '-8px',
              }}
            >
              {value}
            </ConditionalLink>
          )}
          style={{ wordBreak: 'break-word' }}
        />
      </ConditionalTooltip>
    </ListItem>
  );
}

export default CardWithIcon;
